import React, { useEffect, useState } from "react";
import HeartIcon from "../../../assets/icons/ABHA-icons/heart-icon";
import TickIcon2 from "../../../assets/icons/ABHA-icons/tick2-icon";
import TickIcon3 from "../../../assets/icons/ABHA-icons/tick3-icon";
import GovIcon from "../../../assets/icons/ABHA-icons/gov-icon";
import InputField from "../../forms/input-field";
import { Form, Formik } from "formik";
import errorToast from "../../helper-components/error-toast";
import AddButton from "../../buttons/button";
import * as Yup from "yup";
import { RefreshCw } from "lucide-react";
import { url } from "../../../redux/config";
import { accessTokenAction } from "../../../redux/actions/admin-customer-action";
import Adhaar from "../abha/adhaar";
import InputPage from "./input-page";
import Otp from "../otp";
import OTP from "./otp";
import ABHA from "./abha";
import ListPage from "./list-page";
import OTP2 from "./otp2";
import Last from "./last";

function MainPage({ findABHApopup, setFindABHApopup }) {
  const [method, setMethod] = useState("adhaar");
  const [status, setStatus] = useState("main");
  const [position, setPosition] = useState(0);
  const [adhaarAccessToken, setAdhaarAccessToken] = useState("");
  const [adhaarX_Token, setAdhaarX_Token] = useState("");
  const [loading, setLoading] = useState(false);
  const [ABHAlist, setABHAlist] = useState([]);

  const [adhaarTokenExpiresIn, setAdhaarTokenExpiresIn] = useState("");
  const [txnId, setTxnId] = useState("");
  const [message, setmessage] = useState("");
  const [drivingSuccessData, setDrivingSuccessData] = useState(null);
  const [adhaarSuccessData, setAdhaarSuccessData] = useState(null);
  const [newABHAaddress, setNewABHAaddress] = useState(null);

  const [adhaarNo, setAdhaarNo] = useState("");
  const [showVerification, setShowVerification] = useState(true);
  const [mathQuestion, setMathQuestion] = useState({
    question: "",
    answer: "",
  });
  const [verificationError, setVerificationError] = useState("");

  const closeModal = () => {
    setFindABHApopup(false);
  };

  // Handle ESC key press
  // useEffect(() => {
  //   const handleEscape = (e) => {
  //     if (e.key === "Escape" && findABHApopup) {
  //       closeModal();
  //     }
  //   };

  //   document.addEventListener("keydown", handleEscape);
  //   return () => document.removeEventListener("keydown", handleEscape);
  // }, [findABHApopup]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (findABHApopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [findABHApopup]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  // const getABHA = async (data, mobile) => {
  //   try {
  //     const response = await axios.post(
  //       `${url}/abha-integration/search-abha-using-mobile`,
  //       {
  //         mobile: mobile,
  //         accessToken: data,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     console.log("Response:", response);
  //     successToast("OTP is sent");
  //     setTxnId(response?.data?.data?.abdmResponse?.txnId);
  //     setmessage(response?.data?.data?.abdmResponse?.message);
  //     console.log(response?.data?.data?.abdmResponse?.message);
  //     setStatus("OTP Verification");
  //     setPosition(2);

  //     setLoading(false);
  //     //   setPopUp(true);

  //     return response.data;
  //   } catch (error) {
  //     console.log("hhhhhhhhhhhhhhhh", error?.response?.data);
  //     errorToast(error?.response?.data?.message);
  //     console.error(
  //       "Error sending OTP:",
  //       error.response?.data || error.message
  //     );
  //     setLoading(false);
  //     // throw error;
  //   }
  // };

  // const onsave = (values) => {
  //   // if (verificationError !== "") return errorToast(verificationError);
  //   setLoading(true);
  //   if (captchaVerified == false) return errorToast("Captcha is wrong");
  //   dispatch(
  //     accessTokenAction((data) => {
  //       // setAdhaarNo(values.adhaar);

  //       let token = data?.data?.sessionToken?.accessToken;

  //       setAdhaarAccessToken(data?.data?.sessionToken?.accessToken);
  //       if (token == "" || token == undefined || token == null) {
  //         errorToast("Failed to get AccessToken");
  //       }
  //       setAdhaarTokenExpiresIn(data?.data?.sessionToken?.expiresIn);
  //       getABHA(data?.data?.sessionToken?.accessToken, values.adhaar);

  //       // getABHA(data?.data?.sessionToken?.accessToken);
  //       // setAccessToken(data?.data?.sessionToken?.accessToken);
  //       // setPopUp(true);
  //       // setLoading(false);
  //     }, onTokenFail)
  //   );
  // };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-[rgba(0,0,0,0.7)] backdrop-blur-sm z-[2200]"
      // onClick={handleOverlayClick}
    >
      {console.log("??????????????????", adhaarAccessToken, txnId)}
      <div className="bg-white w-[80%] h-[90%] rounded-lg flex flex-col overflow-hidden text-[var(--abha-fg)]">
        {/* Fixed Nav Section */}

        {/* Scrollable Content Section */}
        <div className="flex-1 overflow-y-auto custom-scrollbar px-6 ">
          {status === "main" && (
            <InputPage
              setAdhaarAccessToken={setAdhaarAccessToken}
              setTxnId={setTxnId}
              closeModal={closeModal}
              setMethod={setMethod}
              setStatus={setStatus}
              setPosition={setPosition}
            />
          )}
          {status === "otp" && (
            <OTP
              setABHAlist={setABHAlist}
              setAdhaarX_Token={setAdhaarX_Token}
              setAdhaarSuccessData={setAdhaarSuccessData}
              adhaarAccessToken={adhaarAccessToken}
              txnId={txnId}
              setTxnId={setTxnId}
              closeModal={closeModal}
              setMethod={setMethod}
              setStatus={setStatus}
              setPosition={setPosition}
            />
          )}
          {status === "abha" && (
            <ABHA
              adhaarSuccessData={adhaarSuccessData}
              adhaarX_Token={adhaarX_Token}
              adhaarAccessToken={adhaarAccessToken}
              txnId={txnId}
              closeModal={closeModal}
              setMethod={setMethod}
              setStatus={setStatus}
              setPosition={setPosition}
            />
          )}
          {status === "list" && (
            <ListPage
              setTxnId={setTxnId}
              setAdhaarAccessToken={setAdhaarAccessToken}
              ABHAlist={ABHAlist}
              adhaarSuccessData={adhaarSuccessData}
              adhaarX_Token={adhaarX_Token}
              adhaarAccessToken={adhaarAccessToken}
              txnId={txnId}
              closeModal={closeModal}
              setMethod={setMethod}
              setStatus={setStatus}
              setPosition={setPosition}
            />
          )}
          {status === "otp2" && (
            <OTP2
              setABHAlist={setABHAlist}
              setAdhaarX_Token={setAdhaarX_Token}
              setAdhaarSuccessData={setAdhaarSuccessData}
              adhaarAccessToken={adhaarAccessToken}
              txnId={txnId}
              setTxnId={setTxnId}
              closeModal={closeModal}
              setMethod={setMethod}
              setStatus={setStatus}
              setPosition={setPosition}
            />
          )}
          {status === "last" && (
            <Last
              adhaarSuccessData={adhaarSuccessData}
              adhaarX_Token={adhaarX_Token}
              setABHAlist={setABHAlist}
              setAdhaarX_Token={setAdhaarX_Token}
              setAdhaarSuccessData={setAdhaarSuccessData}
              adhaarAccessToken={adhaarAccessToken}
              txnId={txnId}
              setTxnId={setTxnId}
              closeModal={closeModal}
              setMethod={setMethod}
              setStatus={setStatus}
              setPosition={setPosition}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default MainPage;
